import React from "react";
import * as XLSX from "xlsx";

const ReportCountDownload = ({
  children,
  fileName = "default",
  sheetName = "Sheet1",
  reportData,
  headerBold = true,
}) => {
  // Function to export Excel
  const exportToExcel = () => {
    // Create a new worksheet
    const worksheet = XLSX.utils.aoa_to_sheet([]);

    // Loop through the reportData array to dynamically add headers and data
    reportData.forEach((section) => {
      XLSX.utils.sheet_add_aoa(worksheet, [[section.header]], {
        origin: section.headerCell,
      });

      // Convert the section's data object to an array of [key, value] pairs for Excel export
      const formattedData = Object.entries(section.data).map(
        ([label, count]) => [label, count]
      );

      // Add the data starting at the specified startingDataCell (e.g., "A2")
      XLSX.utils.sheet_add_aoa(worksheet, formattedData, {
        origin: section.startingDataCell,
      });

      // Set the style for the header if headerBold is true
      if (headerBold) {
        // Convert the headerCell (e.g., "A1") into its row and column index
        const cellAddress = XLSX.utils.decode_cell(section.headerCell);

        // Access the header cell based on its address
        const headerCell = worksheet[XLSX.utils.encode_cell(cellAddress)];

        // Apply the bold styling to the header cell
        if (headerCell) {
          headerCell.s = {
            font: {
              bold: true,
              sz: 12, // optional, set size
              color: { rgb: "000000" }, // optional, set color
            },
          };
        }
      }
    });

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Export the workbook as an Excel file (triggering a download)
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return <div onClick={exportToExcel}>{children}</div>;
};

export default ReportCountDownload;
